import { useCallback } from 'react';
import { AddCustomItemModal } from '@/components/modals/AddCustomItemModal';

export interface AddCustomDispositionModalProps {
  open: boolean;
  theme?: string;
  onSave: (data: { dispositionValue: string }) => void;
  onCancel: () => void;
}

export function AddCustomDispositionModal({
  open,
  theme,
  onSave,
  onCancel,
}: AddCustomDispositionModalProps) {
  const handleSave = useCallback((value: string) => {
    onSave({ dispositionValue: value });
  }, [onSave]);

  return (
    <AddCustomItemModal
      open={open}
      title="Add Custom Call Disposition"
      fieldLabel="Call Disposition"
      placeholder="Enter disposition..."
      requiredMessage="Disposition required."
      inputClassName="kstc-input kst-disposition-input"
      theme={theme}
      onSave={handleSave}
      onCancel={onCancel}
    />
  );
}

(window as any).AddCustomDispositionModalReact = AddCustomDispositionModal;
